import {endpoint} from "./endpoint";

export const existingCluster = endpoint({
  url: "/manage/existingcluster",
  method: "post",
  params: undefined,
  payload: undefined,
  validate: undefined,
  shape: undefined,
});
